import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// MSAL v5 popup: the redirect page must broadcast the auth response to the parent window
if (window.location.pathname.includes('azureoauthresponse') &&
    (window.location.hash.includes('code=') || window.location.hash.includes('error='))) {
  // @ts-ignore - subpath export resolved at runtime
  import('@azure/msal-browser/redirect-bridge').then((m: any) => {
    m.broadcastResponseToMainFrame().catch(() => window.close());
  });
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
